import CustomFormVerify from '@comp/CustomVerifyForm';
import { useUserData } from '@hooks/useUserData';
import { ContentData } from '@root/constants/formData/types';
import { OnSubmitParams, useOnSubmit } from '@root/hooks/useOnSubmit';
import React from 'react';
import { Oval } from 'react-loader-spinner';
import { useParams } from 'react-router-dom';

type CustomMainProps = {
  mainContent: ContentData['main'];
  children?: React.ReactNode;
  formData: {
    title: string;
  };
  redirectPaths: OnSubmitParams['redirectPaths'];
};

const CustomMainVerify = (props: CustomMainProps) => {
  const { redirectPaths, children, formData, mainContent } = props;
  const { id } = useParams();
  const { userData } = useUserData(id);
  const { onSubmit } = useOnSubmit({
    redirectPaths,
    merchant:
      userData && userData.options.merchant ? userData.options.merchant : '',
    token: userData ? userData.token : undefined
  });

  if (userData) {
    return (
      <CustomFormVerify
        onSubmit={onSubmit}
        formData={formData}
        mainContent={mainContent}
        userData={userData}
      >
        {children
          ? React.Children.map(children, (child) => {
              if (React.isValidElement<{ userData: typeof userData }>(child)) {
                return React.cloneElement(child, { userData });
              }
            })
          : children}
      </CustomFormVerify>
    );
  }
  return (
    <section className="cardProof">
      <div className="container-s">
        <Oval wrapperClass="centred-block" />
      </div>
    </section>
  );
};

export default CustomMainVerify;
